import { memo } from 'react'

import { VideocamOffOutlined, VideocamOutlined } from '@material-ui/icons'

import useUserCamera from '@tabeeb/modules/presentation/hooks/useUserCamera'
import { ToggleCamera } from '@tabeeb/shared/constants/keyboardShortcuts'
import ShortcutTooltip from '@collaborate-health/uikit/components/ShortcutTooltip'
import { useSelector } from '@tabeeb/store'
import { getCurrentCallUserId } from '@tabeeb/modules/presentation/selectors'
import { getUserById } from '@tabeeb/modules/../users/selectors'
import ToolbarButton from '../ToolbarButton'

const MuteUserCameraToolbarButton = () => {
  const userId = useSelector<number>(getCurrentCallUserId)
  const user = useSelector((state) => getUserById(state, { Id: userId }))

  const { isMuted, selectedCallUser, currentUserId, handleClick } = useUserCamera({ user })

  return (
    <ShortcutTooltip
      title={isMuted ? 'Unmute camera' : 'Mute camera'}
      keys={selectedCallUser?.id === currentUserId ? ToggleCamera : []}
    >
      <ToolbarButton Icon={isMuted ? VideocamOffOutlined : VideocamOutlined} onClick={handleClick} />
    </ShortcutTooltip>
  )
}

export default memo(MuteUserCameraToolbarButton)

